export default "__VITE_ASSET__CEHk_jTL__"